<template>
  <transition name="fade">
    <div class="userModal" v-if="show" v-on:click="showUserSelector = false">
      <div class="overlay"></div>
      <div class="modalContent">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <h4 class="title" v-if="id">Edit Social Media</h4>
        <h4 class="title" v-else>Add Social Media</h4>
        <form v-on:submit.prevent="handleSubmit">
          <div class="formCnt">
            <div class="pdfCover" v-on:click="addImage"
              v-if="media" :style="{'background-image': `url(${media.imageMd})`}"></div>
            <div class="pdfCover noImg" v-else v-on:click="addImage"></div>
            <div class="fieldGroup">
              <div :class="{fieldCnt: true}">
                <label>Name</label>
                <input type="text" class="field" placeholder="Name..."
                  v-model="form.title.model">
              </div>
            </div>
            <div class="fieldGroup">
              <div :class="{fieldCnt: true}">
                <label>Url</label>
                <input type="text" class="field" placeholder="https://..."
                  v-model="form.buttonUrl.model">
                <div class="fieldHint">Url to go when social media clicked.</div>
              </div>
            </div>
          </div>
          <div :class="{btnCnt: 1, saveDisabled: !media}">
            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)" v-if="!saving">
              Cancel
            </button>
            <button class="btn btnPrimary" v-if="id && !saving">
              Save Changes
            </button>
            <button class="btn btnPrimary" v-if="!id && !saving">
              Add Social Media
            </button>
            <button class="btn btnPrimary saving" type="button" v-if="saving">
              Saving...
            </button>
          </div>
        </form>
      </div>
      <MediaSelector ref="mediaSelector"/>
      <Confirmation ref="confirmDialog"/>
    </div>
  </transition>
</template>

<script>
import MediaSelector from '@/components/MediaSelector.vue';
import Confirmation from '@/components/Confirmation.vue';

export default {
  components: { MediaSelector, Confirmation },
  data() {
    return {
      id: null,
      loading: false,
      show: false,
      saving: false,
      media: null,
      cover: null,
      showPdfOptions: false,
      form: {
        title: { model: '', error: null },
        buttonLabel: { model: '', error: null },
        buttonUrl: { model: '', error: null },
      },
    };
  },
  methods: {
    open(d, n) {
      this.id = (d && d.id) ? d.id : null;
      this.form.title.model = (d && d.name) ? d.name : '';
      this.form.buttonUrl.model = (d && d.url) ? d.url : '';
      this.media = (d && d.media) ? d.media : null;
      this.next = n;
      this.show = true;
      this.saving = false;
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    doNothing() {},
    addImage() {
      this.$refs.mediaSelector.open({ type: 'image' }, (b, m) => {
        if (!b) return;
        const media = m.gallery ? m.gallery[0] : m;
        if (m.type !== 'image') {
          this.$refs.confirmDialog.open({
            title: 'Media Not Supported',
            desc: 'Only support media image for social media thumbnail',
            error: true,
          });
          return;
        }
        this.media = media;
      });
    },
    handleSubmit() {
      if (this.saving || !this.media) return;
      const formData = {
        name: this.form.title.model,
        url: this.form.buttonUrl.model,
        media: this.media,
      };
      this.close(true, formData);
    },
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
.formCnt{
  position: relative;
  padding-left: 140px;
  .pdfCover{
    width: 100px; height: 100px;
    background-color: #ccc;
    padding: 0;
    border-radius: 50px;
    cursor: pointer;
    position: absolute;
    left: 0; top: 6px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    &.noImg{
      background-image: url(../assets/image-black.png);
      background-size: 36px auto;
      opacity: .36;
    }
  }
}
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;

  .addCategory{
    color: #0245a7;
    display: inline-block;
    float: right;
    border-radius: 50px;
    margin-top: 4px;
    padding: 4px 10px 6px;
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    img{
      height: 18px;
      float: left;
      margin-right: 7px;
      margin-top: 1px;
    }
  }

  .fieldCnt{
    position: relative;
    .fieldLoading{
      position: absolute;
      right: 10px; top: 33px;
      z-index: 3;
      img{
        height: 24px;
      }
    }
    .theMan{
      position: relative;
      border-radius: 5px;
      border: #ccc 1px solid;
      display: flex;
      align-items: center;
      border-color: #0e5dd2;
      background-color: #e9f2ff;
      padding-left: 54px;
      padding-right: 38px;
      box-sizing: border-box;
      height: 48px;
      h5{
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-size: 17px;
        color: #0747a6;
        font-weight: 600;
        margin: 0;
      }
      .profilePict{
        width: 36px; height: 36px;
        position: absolute;
        left: 10px; top: 50%;
        margin-top: -18px;
        background-color: #0e5dd2;
        border-radius: 50%;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        &.email{
          background-color: #e9f2ff;
          background-image: url(../assets/envelope.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .close{
        position: absolute;
        right: 6px; top: 50%;
        border-radius: 50%;
        margin-top: -15px;
        width: 30px; height: 30px;
        background-image: url(../assets/close.png);
        background-size: 12px auto;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        opacity: .5;
        // transition: all .2s ease;
        &:hover{
          opacity: .8;
          background-color: #fff;
        }
      }
      &.hasError{
        background-color: #fff4f4;
        border-color: red;
        h5{
          color: red;
        }
        .profilePict{
          background-color: red;
          &.email{
            background-color: #fff4f4;
          }
        }
      }
    }
  }
  .fieldCnt.hasError{
    .field{
      border-color: red;
    }
    .fieldHint{
      display: none;
    }
    .fieldError{
      display: block;
    }
  }
  .fieldCnt.hasPrefix{
    position: relative;
    .field{
      padding-left: 40px;
    }
    .fieldPrefix{
      position: absolute;
      left: 10px; top: 35px;
      z-index: 3;
      color: #767676;
    }
  }

  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    margin: auto;
    border-radius: 5px;
    padding: 24px 80px 40px;
    overflow: hidden;
    transition: all .3s ease;
    width: 480px;
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading-2.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    h4.title{
      font-size: 24px;
      margin: 0;
      font-weight: normal;
      margin-bottom: 20px;
      padding-left: 140px;
    }
    .btnCnt{
      text-align: right;
      border-top: #eee 1px solid;
      margin: 0 -80px -40px;
      padding: 12px 30px 2px;
      &.saveDisabled{
        .btnPrimary{
          background-color: #ccc;
          color: #999;
          box-shadow: none;
          cursor: default;
        }
      }
    }
    .btn{
      margin-left: 5px;
      margin-bottom: 10px;
      &.saving{
        background-color: #ccc;
        color: #999;
        cursor: default;
        box-shadow: none;
      }
    }
  }
}
</style>
